import { render, staticRenderFns } from "./LessonChatDesktop.vue?vue&type=template&id=7dd771d0&scoped=true"
import script from "./LessonChatDesktop.vue?vue&type=script&lang=js"
export * from "./LessonChatDesktop.vue?vue&type=script&lang=js"
import style0 from "./LessonChatDesktop.vue?vue&type=style&index=0&id=7dd771d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd771d0",
  null
  
)

export default component.exports